import '../styles/app.scss';

/** Autoload */
import './autoload/_vanilla-jq';
import './autoload/_bootstrap';
import './autoload/_fonts';
import fetchInject from 'fetch-inject';

/** Util */
import './util/current-breakpoint';

/** Make variables globals */
window.fetchInject = fetchInject;
window.currentBreakpoint = require( './util/current-breakpoint' ).currentBreakpoint;
